export default {
  methods: {
    contactUs() {
      window.location.href = "https://chatlink.ichatlinks.net/widget/standalone.html?eid=57b4105e697d0bfb7ff5505d79ad9f5d&agentid=030e1a7d8e5a77aa75d648f3cc918b08&language=en";
    }
  }
}